import { privateAPI } from '.';

export const taskVaultAPI = privateAPI.injectEndpoints({
  endpoints: build => ({
    markTaskVaultAsRead: build.mutation({
      query: ({ projectId } = {}) => ({
        url: '/client-portal/task-vault/mark-as-read',
        method: 'POST',
        body: projectId ? { project_id: projectId } : undefined,
      }),
      invalidatesTags: ['ProjectsList'],
    }),
  }),
});

export const { useMarkTaskVaultAsReadMutation } = taskVaultAPI;
